"use client";

import { useRef } from "react";
export default function IndustriesServed() {
  const tickerRef = useRef<HTMLDivElement>(null);
  const industries = [{
    name: "Food & Beverage",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/food_beverage_industry_logo.png"
  }, {
    name: "Retail & Distribution",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/retail_distribution_industry_logo.png"
  }, {
    name: "Manufacturing",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/manufacturing_industry_logo.png"
  }, {
    name: "HoReCa",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/horeca_industry_logo.png"
  }, {
    name: "Import & Export",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/import_export_industry_logo.png"
  }, {
    name: "Wholesale",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/wholesale_industry_logo.png"
  }, {
    name: "Agriculture",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/agriculture_industry_logo.png"
  }, {
    name: "Logistics",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/logistics_industry_logo.png"
  }];
  return <section id="industries-served" className="relative bg-[#F6F3EC] py-20 overflow-hidden" style={{
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
  }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground text-center">
          Industries Served
        </h2>
        <p className="mt-4 text-lg text-muted-foreground text-center max-w-2xl mx-auto">
          Trusted by leading businesses across diverse sectors worldwide
        </p>
      </div>

      <div className="relative">
        <div ref={tickerRef} className="flex gap-12 [animation:ticker_40s_linear_infinite] hover:[animation-play-state:paused]" style={{
        width: "fit-content"
      }}>
          {}
          {[...industries, ...industries, ...industries].map((industry, i) => <div key={i} data-index={i} className="group relative flex-shrink-0 w-64 h-40 bg-white rounded-sm shadow-soft overflow-hidden transition-all duration-[var(--duration-medium)] hover:shadow-medium hover:-translate-y-1">
              <div className="absolute inset-0 flex items-center justify-center p-8">
                <img src={industry.logo} alt={`${industry.name} logo`} className="w-full h-full object-contain filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-[var(--duration-medium)]" />
              </div>

              <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] bg-gradient-to-t from-primary to-primary/90 p-4">
                <h3 className="text-xl font-display font-bold text-white text-center">
                  {industry.name}
                </h3>
              </div>

              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] bg-accent/5 pointer-events-none" />
            </div>)}
        </div>

        <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-[#F6F3EC] to-transparent pointer-events-none z-10" />
        <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-[#F6F3EC] to-transparent pointer-events-none z-10" />
      </div>

      <style jsx>{`
        @keyframes ticker {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
      `}</style>
    </section>;
}